$(document).ready(function () {
    $('.mobile-nav__btn-toggle').on('click', function() {
        $('.hamburger-menu').toggleClass('animate');
        $('.mobile-nav__toggle-menu').stop(true).slideToggle(300);
    })
});
